import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../api'

interface LikeParams {
  postId: string
  userId: string
  likeId?: string
}

export const useLike = () => {
  const queryClient = useQueryClient()

  const addLike = async ({ postId, userId }: LikeParams) => {
    const { data, error } = await supabase
      .from('user_activities')
      .insert({
        user_id: userId,
        post_id: postId,
        type: 'like',
        created_at: new Date().toISOString()
      })
      .select()
      .single()

    if (error) throw error
    return data
  }

  const removeLike = async ({ postId, userId, likeId }: LikeParams) => {
    const { data, error } = await supabase
      .from('user_activities')
      .delete()
      .match({
        id: likeId,
        user_id: userId,
        post_id: postId,
        type: 'like'
      })
      .select()
      .single()

    if (error) throw error
    return data
  }

  const addLikeMutation = useMutation({
    mutationFn: addLike,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries(['reactions'])
      queryClient.invalidateQueries(['userActivities'])
      queryClient.invalidateQueries(['useUserActivitiesCount', variables.postId, 'like'])
    }
  })

  const removeLikeMutation = useMutation({
    mutationFn: removeLike,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries(['reactions'])
      queryClient.invalidateQueries(['userActivities'])
      queryClient.invalidateQueries(['useUserActivitiesCount', variables.postId, 'like'])
    }
  })

  return {
    addLike: addLikeMutation.mutateAsync,
    removeLike: removeLikeMutation.mutateAsync,
    isLoading: addLikeMutation.isLoading || removeLikeMutation.isLoading
  }
}
